import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Stack,
  Divider,
  Grid,
  Paper,
  Chip,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import Label from '../label';
import { dateConverter } from '../../utils/dateConveter';
import tokenTransferServices from '../../services/tokenTransferServices';
import { useSnackbar } from 'notistack';
import MnemonicUploadModal from './MnemonicUploadModal';
const TransactionDetailsModal = ({ open, data, onClose, getTransaction }) => {
  const user = useSelector(state => state.user.data);
  const { enqueueSnackbar } = useSnackbar();
  const [showMnemonicModal, setShowMnemonicModal] = useState(false);
  const [transactionId, setTransactionId] = useState(null);
  
  if (!open || !data) return null;
  // Get status color and variant for Transaction Details Label component
  const getStatusColor = (status) => {
    switch (status) {
      case 'COMPLETED':
        return { color: 'success', variant: 'filled', label: 'Transaction Complete' };
      case 'OPTIN_PENDING':
        return { color: 'info', variant: 'filled', label: 'Awaiting Receiver Opt-In' };
      case 'PAYMENT_REJECTED_BY_SENDER':
        return { color: 'error', variant: 'filled', label: 'Payment Rejected' };
      case 'OPTIN_COMPLETED':
        return { color: 'success', variant: 'filled', label: 'Receiver Opted In' };
      case 'OFFER_REJECTED_BY_SENDER':
        return { color: 'error', variant: 'filled', label: 'Transaction Cancelled' };
      default:
        return { color: 'default', variant: 'filled', label: 'Pending' };
    }
  };
  let status = data.status;
  if (data.status=="PENDING"||!data.status) {
    status = data.isOptinCompleted?'OPTIN_COMPLETED':'OPTIN_PENDING';
  }
  const statusConfig = getStatusColor(status);
  const handleStatusUpdate = async (transactionId,status) => {
    try{
    const response = await tokenTransferServices.statusUpdate({transactionId,status});
    if(response.success){
      enqueueSnackbar('Status updated successfully', { variant: 'success' });
      onClose();
      getTransaction();
    }else{
      enqueueSnackbar(response.message, { variant: 'error' });
    }
    }catch(error){
      enqueueSnackbar('Something went wrong', { variant: 'error' });
    }
  }
  const handleTransactionComplete =  (transactionId) => {
    setTransactionId(transactionId);
    setShowMnemonicModal(true);
  }
  const handleCloseMnemonicModal = () => {
    setShowMnemonicModal(false);
    setTransactionId(null);
    // onClose();
    getTransaction();
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xl"
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          margin: '20px auto',
          minWidth: {xs:'auto',sm:'auto',md:'800px',lg:'800px',xl:'800px'}
        }
      }}
    >
      <DialogTitle sx={{ 
        fontWeight: 600, 
        fontSize: {xs:16,sm:18,md:20,lg:22,xl:24},
        borderBottom: '1px solid',
        borderColor: 'divider',
        pb: 2
      }}>
        Transfer Details
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ pt: 3,marginTop:"20px" }}>
      <Box>
             <Typography variant="h6" sx={{ mb: 3, color: 'primary.main', fontWeight: 600 }}>
               Your Status
             </Typography>
             
             {/* Status Icon and Title */}
             <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
               <Box
                 sx={{
                   width: 40,
                   height: 40,
                   borderRadius: '50%',
                   bgcolor: statusConfig.color === 'warning' ? 'warning.light' : 
                            statusConfig.color === 'error' ? 'error.light' :
                            statusConfig.color === 'success' ? 'success.light' :
                            statusConfig.color === 'info' ? 'info.light' : 'grey.300',
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center'
                 }}
               >
                 <Typography variant="h6" sx={{ 
                   color: statusConfig.color === 'warning' ? 'warning.main' : 
                          statusConfig.color === 'error' ? 'error.main' :
                          statusConfig.color === 'success' ? 'success.main' :
                          statusConfig.color === 'info' ? 'info.main' : 'grey.600'
                 }}>
                   {statusConfig.color === 'warning' ? '⏰' : 
                    statusConfig.color === 'error' ? '❌' :
                    statusConfig.color === 'success' ? '✅' :
                    statusConfig.color === 'info' ? 'ℹ️' : '⏳'}
                 </Typography>
               </Box>
               <Typography variant="h5" sx={{ fontWeight: 600, color: 'text.primary' }}>
                 {statusConfig.label}
               </Typography>
             </Stack>
           </Box>

         
        <Stack spacing={3} sx={{marginTop:"20px"}}>
        <Divider />
          {/* Asset Information */}
          <Paper elevation={0} sx={{bgcolor: 'grey.50', borderRadius: 2 ,width:"100%" }}>
            <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
            Transfer Summary
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={data.image ? 8 : 12}>
                <Stack spacing={2}>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                      Asset Name
                    </Typography>
                    <Typography variant="body1" fontWeight={500}>
                      {data.assetName || 'N/A'}
                    </Typography>
                  </Box>
                  <Box sx={{display:"flex",gap:"40px"}}>
                  <Box sx={{display:"flex",gap:2}}>
                    <Box>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                      Tokens
                    </Typography>
                    <Typography variant="body1" fontWeight={500}>
                      {data.tokens || 'N/A'}
                    </Typography>
                    </Box>
                    <Box >
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Offer Date
                  </Typography>
                  <Typography variant="body1" fontWeight={500}>
                    {data.offerDate || '-'}
                  </Typography>
                  </Box>
                  </Box>
                </Box>
                </Stack>
              </Grid>
            </Grid>
           </Paper>
          <Paper elevation={0} sx={{bgcolor: 'grey.50', borderRadius: 2 }}>
            <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
              Receiver Information
            </Typography>
            <Stack spacing={2}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Receiver DLT Wallet Name:
                </Typography>
                <Typography variant="body1" fontWeight={500}>
                  {data.receiverDltWalletname || '-'}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Receiver Legal Name:
                </Typography>
                <Typography variant="body1" fontWeight={500}>
                  {data.receiverLegalName || '-'}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Receiver DLT Account:
                </Typography>
                <Typography variant="body1" fontWeight={500}>
                  {data.receiver?.dltAccount ? '...' + data.receiver.dltAccount.slice(-10) : '-'}
                </Typography>
              </Box>
            </Stack>
          </Paper>
         </Stack>
      </DialogContent>
       {
       ((!data.status||data.status=="PENDING")&&(data.isOptinCompleted||!data.isOptinCompleted)) && 
        <DialogActions>
        
        {data.isOptinCompleted&& data.status!=="COMPLETED"&&(
          <>
            <Button onClick={()=>handleTransactionComplete(data._id)} variant="contained" fullWidth >
              Complete
            </Button>
            <Button onClick={()=>handleStatusUpdate(data._id,'OFFER_REJECTED_BY_SENDER')} variant="outlined" fullWidth >
              Reject
            </Button>
          </>
        )}
        
        </DialogActions>}
      
      <MnemonicUploadModal
        open={showMnemonicModal}
        onClose={()=>handleCloseMnemonicModal()}
        transactionId={transactionId}
        closeAll={onClose}
      />
    </Dialog>
  );
};

export default TransactionDetailsModal;
